import React, { Component } from 'react';
import { Button, Glyphicon } from 'react-bootstrap';
import '../../content/css/OrganizationList.css';

export default class OrganizationListRow extends Component {

    constructor(props) {
        super(props);

        this.handleRemove = this.handleRemove.bind(this);
    }

    handleRemove() {
        this.props.onRemove(this.props.name);
    }

    render() {
        return (
            <tr id={`row-${this.props.index}`} className="organization-row" >
                <td>
                    <span>{this.props.name}</span>
                    <Button bsSize="xsmall" onClick={this.handleRemove}>
                        <Glyphicon glyph='trash' />
                    </Button>
                </td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/OrganizationListRow.js